export default {
  // 根据当前数据动态下载提货单 PDF
  downloadPickupPdf: '/ygsjzs/yxPickupOrder/downloadPickupPdf',
  // 新增提货订单
  insertYxPickupOrder: '/ygsjzs/yxPickupOrder/insertYxPickupOrder',
  // 修改提货订单
  updateYxPickupOrder: '/ygsjzs/yxPickupOrder/updateYxPickupOrder',
  // 审批提货订单
  approvalYxPickupOrder: '/ygsjzs/yxPickupOrder/approvalYxPickupOrder',
  // 删除提货订单
  deleteYxPickupOrder: '/ygsjzs/yxPickupOrder/deleteYxPickupOrder',
  // 作废提货订单
  ZfYxPickupOrder: '/ygsjzs/yxPickupOrder/ZfYxPickupOrder',
  // 查询供应商列表
  selectYxcSupplierList: 'ygsjzs/yxcPriceOrder/selectYxcSupplierList',
  // 查询提货订单详情
  selectYxPickupOrderByPickupId: '/ygsjzs/yxPickupOrder/selectYxPickupOrderByPickupId',
  // 分页查询提货订单列表
  selectYxPickupOrderByPage: '/ygsjzs/yxPickupOrder/selectYxPickupOrderByPage',
  selectYxPickupOrderByPageV2: '/ygsjzs/yxPickupOrder/selectYxPickupOrderByPageV2',
  // 云采关联提货选择：登录后可查外库卸货单
  selectYxPickupOrderForRelationByPage: '/ygsjzs/yxPickupOrder/selectYxPickupOrderForRelationByPage',
  // 导出
  exportYxPickupOrder: '/ygsjzs/yxPickupOrder/exportYxPickupOrderV2',
  updateYxPlanPickupOrder: '/ygsjzs/yxPickupOrder/updateYxPlanPickupOrder',
  updateYxPlanPickupOrder2: '/ygsjzs/wlVehiclePlan/updateYxPlanPickupOrder',
  // 修改提货的计划数量
  updateYxPlanPickupNum: '/ygsjzs/yxPickupOrder/updateYxPlanPickupNum',
  // 编辑直接保存；修改留存车辆仓库原值
  editYxPlanVehicle: '/ygsjzs/yxPickupOrder/editYxPlanVehicle',
  selectVehicleBeforeChange: '/ygsjzs/yxPickupOrder/selectVehicleBeforeChange',
  // 修改车辆
  updateYxPlanVehicle: '/ygsjzs/yxPickupOrder/updateYxPlanVehicle',
  // 确认装货
  editCYWlVehiclePlanCc: '/ygsjzs/wlVehiclePlan/editCYWlVehiclePlanCc',
  // 按提货单号查询
  selectYxPickupOrderByPickupNum: '/ygsjzs/yxPickupOrder/selectYxPickupOrderByPickupNum',
  // 退回云销订单
  bakeYxPickupOrder: '/ygsjzs/yxPickupOrder/bakeYxPickupOrder',
  // 提货日期设置
  updateLyWarConf: '/ygsjzs/lyWarConf/updateLyWarConf',
  selectLyWarConfByList: '/ygsjzs/lyWarConf/selectLyWarConfByList',
  // 导出发货单
  exportXzFhd: '/ygsjzs/yxPickupOrder/xzFhd',
  // 修改规格
  updateYxPlanNewSpecId: '/ygsjzs/yxPickupOrder/updateYxPlanNewSpecId'
}
